import { render } from "./DefaultHeader.vue?vue&type=template&id=32662e59"
import script from "./DefaultHeader.vue?vue&type=script&lang=js"
export * from "./DefaultHeader.vue?vue&type=script&lang=js"

import "./DefaultHeader.vue?vue&type=style&index=0&id=32662e59&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__